// extracted by mini-css-extract-plugin
module.exports = {"totals":"ChartTooltip_totals__3TiBG","comparison":"ChartTooltip_comparison__1hApe","costBasis":"ChartTooltip_costBasis__3QvKM","main":"ChartTooltip_main__1OKGl"};